import React from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import VaporTab from "../../vapor/tab/indexOld";

const DetailTabs = ({activeTab, setActiveTab, contiNew, showFiscalPayments, showIntrastat, showUsedGoods, showWithholding, setSectionalError}) => {
  const sectional = useSelector(state => state.precog.invoiceDetail?.data?.sectionalId);
  const renderTabItems = () => {
    let itemsRet = [{ value: "accounting", content: <FormattedMessage id="preCog.accountingTab.accounting" /> }];

    if (showUsedGoods) {
      itemsRet.push({ value: "usedGoods", content: <FormattedMessage id="preCog.assetsTab.usedGoods" /> });
    }

    if (contiNew.some(c => c.isAsset && c.hasChildren)) {
      itemsRet.push({ value: "asset", content: <FormattedMessage id="preCog.assetsTab.assets" /> });
    }

    if (showIntrastat) {
      itemsRet.push({ value: "intrastat", content: <FormattedMessage id="preCog.intrastatTab.intrastat" /> });
    }

    if (showWithholding) {
      itemsRet.push({ value: "withholding", content: "Ritenute" });
    }

    if (showFiscalPayments){
      itemsRet.push({ value: "fiscal_payments", content: <FormattedMessage id="preCog.assetsTab.fiscal_payments" /> });
    }

    // if (showDeadlines) {
    //   itemsRet.push({ value: "deadlines", content: "Scadenze" });
    // }

    return itemsRet;
  };

  return (
    <div style={{ marginBottom: 24 }}>
      <VaporTab
        containerStyle={{
          fontSize: "24px",
          height: "80px",
          lineHeight: "80px",
          fontWeight: "600"
        }}
        customClass="adjustable"
        items={renderTabItems()}
        onChange={i => {          
          if (i.value === "asset" && (!sectional || sectional ==="null")){
            setSectionalError(true);
          }     
              
          setActiveTab(i.value);
        }
        }
        active={activeTab}
        containerWidth={"55%"}
        itemsWidth={160}
      />
    </div>
  );
};

export default DetailTabs;
